const SALES_ORDER_PROGRAM_MAP = {
  ZRMS: 'RMS-OWN-ESE-RM',
  ZSPO: 'RMS-OWN-ESE-RM',
  ZDON: 'RMS-PRG-FND-CP'
}

function normalizeProgram (program) {
  if (!program) return
  const cleaned = program.replace(/\s/g, '')
  if (cleaned.startsWith('RMS-OWN')) return 'RMS-OWN'
  if (cleaned.startsWith('RMS-PRG')) return 'RMS-PRG'
  return program
}

const PROGRAM_PREFIX_TO_SERVICE_FSID = {
  'RMS-OWN': 'program:rms-own:service:rms-own',
  'RMS-PRG': 'program:rms-prg:service:rms-prg'
}

module.exports = { normalizeProgram, SALES_ORDER_PROGRAM_MAP, PROGRAM_PREFIX_TO_SERVICE_FSID }
